module.exports = __webpack_public_path__ + "static/logo-0c17e323495e573e6cfdda5125ee07a5.png";